import React, { useCallback, useContext, useState } from 'react';


export const CommonContext = React.createContext({
    toggleLanguage: () => { },
    lang: ''
});
const CommonContextProvider = ({ children }) => {
    const [lang, setLang] = useState('hi');

    const toggleLanguage = useCallback(() => {
        setLang(lang === 'hi' ? 'en' : 'hi');
    }, [lang]);

    const value = {
        toggleLanguage,
        lang
    };
    return (
        <CommonContext.Provider value={value} >
            {children}
        </CommonContext.Provider>
    );
};

export const useCommonContext = () => {
    return useContext(CommonContext);
}

export default CommonContextProvider;